import {
  Box,
  Link,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  TextareaAutosize,
} from "@mui/material";
import styles from "../devotee.module.scss";
import CachedIcon from "@mui/icons-material/Cached";
import {
  CustomCalendarIcon,
  CommonButton,
  HcccCard,
  CommonOutlinedButton,
  CustomInputLabel,
  CustomReceiptIcon,
} from "../../common/StyledComponents/StyledFields";
import constants from "../../../config/constants.json";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserName,
} from "../../../infrastructure/backendService";
import EmptyPage from "../../common/emptyPages/emptyPage";
import ToastComponent from "../../common/toastComponent";
import CloseIcon from "@mui/icons-material/Close";
import apiPath from "../../../config/apiPaths.json";
import Pagination from "../../common/pagination/pagination";
import ToastError from "../../common/toast/toastError";
import { isNil } from "lodash";
import CONSTANTS from "../../../config/constants.json";
import { CustomTooltip } from "../../common/muhurtham/muhurtham";
import ErrorPopup from "../../common/ErrorPopup";
import { RoutingURLs, SubRoutingURLs } from "../../common/RoutingURLs";
import { BeatLoader, BounceLoader, ClipLoader } from 'react-spinners';
import DevoteeModeOfPayment from "../../common/modeOfPayment/devoteeModeOfPayment";

interface CommonDonationProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const BookedPooja = (props: CommonDonationProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [bookedPoojaList, setBookedPoojaList] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [showDetails, setShowDetails] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null); // To keep track of the booking being canceled
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [reason, setReason] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState<boolean>(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [buttonDisable, setButtonDisable] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const [requestType, setRequestType] = useState("");
  const [payPalAddToCart, setPayPalAddToCart] = useState("");
  const [itemsList, setItemList] = useState<any[]>([]);
  const [dialogLoading, setDialogLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getPoojaHallListApi();
  }, [pageNumber]);

  const getPoojaHallListApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.bookedPoojaListApi,
      params: {
        sortBy: "id",
        page: pageNumber - 1,
        size: 5,
        direction: "asc",
        username: getUserName(),
      },
      includeToken: true,
    })
      .then((res) => {
        setBookedPoojaList(res.data.content);
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        // toast.error(`${err.message}`);
        // setBookedPoojaList(BookePoojaInfo); // comment this line after getting response 200 from the server
      });
  };

  const onClickBookPooja = () => {
    navigate(`/devoteebooking/${SubRoutingURLs.POOJA_BOOKING_REQUEST}`);
  };
const [itemIds, setItemIds] = useState(0);
  const onPayNowNavigate = (
    totalDonationAmount: any,
    id: number,
    requestType: string,
    status?: string
  ) => {
    const items = [
      {
        itemId: id,
      },
    ];
    sessionStorage.setItem("cartItems", JSON.stringify(items));
    setTotalAmount(totalDonationAmount);
    setRequestType(requestType);
    setItemIds(id);
    handleOpenPaymentDialog();
    // navigate(
    //   `/creditPayment?amount=${totalDonationAmount}&donationType=${requestType}&status=${status}`
    // );
  };

  const onClickReceipt = (receiptId: string) => {
    navigate(`/receipt?receiptID=${receiptId}&userID=${getUserName()}`);
  };

  const onClickStatus = (rowData: any, exclude?: boolean) => {
    if (rowData.status === "FORM_TO_BE_SIGNED" || exclude) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${rowData?.id}/contracts/${rowData?.hallContractFormId}`,
        includeToken: true,
      })
        .then((res) => {
          console.log(res.data);
          exclude ? navigate(
            `/hallForm?username=${res.data?.devoteeUsername}&numberOfGuests=${res.data.eventGuestCount}&hallName=${res.data?.eventHallChargesBreakdown[0].eventHallName}&eventTime=${res.data.eventStartTime}&eventDate=${res.data.eventDate}&eventType=${res.data.eventNature}&hallId=${res.data.eventHallChargesBreakdown[0].eventHallId}&duration=${res.data?.eventHallChargesBreakdown[0].eventDuration}&amount=${res.data?.eventHallChargesBreakdown[0].totalAmount}&hallBookingId=${res.data.hallBookingRequestId}&STATUS=viewcontractform&contractId=${rowData?.hallContractFormId}`
          ) : navigate(
            `/hallForm?username=${res.data?.devoteeUsername}&numberOfGuests=${res.data.eventGuestCount}&hallName=${res.data?.eventHallChargesBreakdown[0].eventHallName}&eventTime=${res.data.eventStartTime}&eventDate=${res.data.eventDate}&eventType=${res.data.eventNature}&hallId=${res.data.eventHallChargesBreakdown[0].eventHallId}&duration=${res.data?.eventHallChargesBreakdown[0].eventDuration}&amount=${res.data?.eventHallChargesBreakdown[0].totalAmount}&hallBookingId=${res.data.hallBookingRequestId}&STATUS=FORM_TO_BE_SIGNED&contractId=${rowData?.hallContractFormId}`
          )
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const deleteRequestApi = () => {
    setIsLoading(true);
    const reqBody = {
      status: 4,
      cancelReason: reason,
    };
    apiRequest({
      method: "PUT",
      endpoint: `${apiPath.cancelBookingRequest}/${selectedId}`,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setIsLoading(false);
        setSelectedId(null);
        setReason("");
        setOpenCancelDialog(false);
        getPoojaHallListApi();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const renderWithData = () => {
    const handleCancelDialogClose = () => {
      setOpenCancelDialog(false);
      setSelectedBooking(null);
      setSelectedId(null);
      setReason("");
    };

    const handleProceedCancel = () => {
      deleteRequestApi();
    };
    const handleCancelClick = (bookingInfo: any) => {
      setSelectedId(bookingInfo.id);
      setSelectedBooking(bookingInfo);
      setOpenCancelDialog(true);
    };

    const buttonContext = (status: string) => {
      if (status === CONSTANTS.HALL_BOOKING_STATUS.BOOKED_PAY_INITIAL_AMOUNT) {
        return "PAY INITIAL AMOUNT";
      } else if (
        status === CONSTANTS.HALL_BOOKING_STATUS.FINAL_PAYMENT_DUE_AND_CONTRACT
      ) {
        return "PAY FINAL DUE AMOUNT";
      } else if (status === CONSTANTS.HALL_BOOKING_STATUS.AMOUNT_DUE_TO_HCCC) {
        return "PAY SETTLEMENT AMOUNT";
      } else {
        return "PAY NOW";
      }
    };
    return (
      <Box>
        <Box className={styles.headButton}>
          <Typography className={styles.heading}>Booked Pooja/Hall</Typography>
          <CommonButton
            sx={{ display: "flex", marginLeft: "auto" }}
            onClick={getPoojaHallListApi}
          >
            <CachedIcon />
          </CommonButton>
          <CommonButton onClick={onClickBookPooja}>
            Book pooja/Hall
          </CommonButton>
        </Box>

        <div className={styles.BookedPoojaCardsLayout}>
          {bookedPoojaList.map((info, i) => (
            <Box
              className={styles.singleCard}
              key={i}
              style={{
                backgroundColor:
                  info.status === CONSTANTS.POOJA_BOOKING_STATUS.BOOKED
                    ? "#F6FFE3"
                    : "#FFF9E4",
              }}
            >
              {" "}
              {info.requestType === "P" ? (
                <img
                  src="/images/templeimagenew.svg"
                  className={styles.image}
                />
              ) : (
                <img
                  src="/images/templeimagenew.svg"
                  className={styles.image}
                />
              )}
              <Box className={styles.poojaDetails}>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
                >
                  {info.requestType === "P" ? (
                    <Box className={styles.bookedPoojaTitle}>
                      <Typography className={styles.title}>
                        {info.poojaName}
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )}
                  {info.requestType === "E" ? (
                    <Box className={styles.bookedPoojaTitle}>
                      <Typography className={styles.title}>
                        {info.priestHallName}
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )}
                  <Box className={styles.locationPriestDate}>
                    <Box className={styles.locationAndPriest}>
                      {info.requestType === "P" ? (
                        <Box className={styles.statusImage}>
                          <img
                            src="/images/location_on.svg"
                            className={styles.smallImage}
                          />
                          <Typography className={styles.locationAndPriestNames}>
                            Location : {info.location}
                          </Typography>
                        </Box>
                      ) : (
                        <Box className={styles.statusImage}>
                          <img
                            src="/images/location_on.svg"
                            className={styles.smallImage}
                          />
                          <Typography className={styles.locationAndPriestNames}>
                            Location : Temple
                          </Typography>
                        </Box>
                      )}

                      <Box
                        className={styles.statusImage}
                        style={{
                          paddingLeft:
                            info.status ===
                              CONSTANTS.POOJA_BOOKING_STATUS.CONFIRMED
                              ? "15px"
                              : "0",
                        }}
                      >
                        {info.requestType === "P" ? (
                          <>
                            <img
                              src="/images/person_3.svg"
                              className={styles.smallImage}
                            />
                            <Typography
                              className={styles.locationAndPriestNames}
                            >
                              Priest : {info.priestHallName}
                            </Typography>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                    {/* <Box>
                              <Typography className={styles.date}>{info.bookingDate}</Typography>
                              <CommonButton>Pay Now</CommonButton>
                           </Box> */}
                  </Box>
                  <Box className={styles.locationPriestDate}>
                    <Box className={styles.locationAndPriest}>
                      <Box className={styles.statusImage}>
                        {info.status ===
                          CONSTANTS.POOJA_BOOKING_STATUS.BOOKED ? (
                          <img
                            src="/images/done_all.svg"
                            className={styles.smallImage}
                          />
                        ) : (
                          <img
                            src="/images/error.svg"
                            className={styles.smallImage}
                          />
                        )}
                        <Typography
                          className={styles.locationAndPriestNames}
                          style={{
                            color:
                              info.status ===
                                CONSTANTS.POOJA_BOOKING_STATUS.BOOKED
                                ? "#43A022"
                                : "#992D0D",
                            fontWeight: "700",
                          }}
                          onClick={() => onClickStatus(info)}
                        >
                          Status : {info.statusDisplayName}
                        </Typography>
                      </Box>
                      {
                        (info.status !== "CANCEL_REQUEST" && info.status !== "CLOSED" && info.status !== "CANCELLED") ? (
                          <Box className={styles.statusImage}>
                            <img
                              src="/images/cancel.svg"
                              className={styles.smallImage}
                            />
                            <Typography
                              className={styles.poojaBookingCancel}
                              onClick={() => handleCancelClick(info)}
                            >
                              Cancel Booking
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        )}
                    </Box>
                  </Box>
                </Box>
                <Box className={styles.dateAndReceiptContainer}>
                  <Box
                    sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}
                  >
                    <div style={{ marginTop: "2px" }}>
                      <CustomCalendarIcon />
                    </div>
                    <Typography className={styles.date}>
                      {info.bookingDate}
                    </Typography>
                  </Box>
                  {info.status === CONSTANTS.POOJA_BOOKING_STATUS.BOOKED || info.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" || info.status === "SETTLEMENT_PENDING" || info.status === "AMOUNT_DUE_TO_DEVOTEE" || info.status === "AMOUNT_DUE_TO_HCCC" || info.status === "CLOSED" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => onClickReceipt(info.receiptId)}
                    >
                      <CustomTooltip title="Receipt Id">
                        <div style={{ marginTop: "2px", display: "flex" }}>
                          <CustomReceiptIcon />
                          <Typography className={styles.receipt}>
                            {info.receiptId}
                          </Typography>
                        </div>
                      </CustomTooltip>
                    </Box>
                  ) : (
                    ""
                  )}
                  {(info.status === CONSTANTS.POOJA_BOOKING_STATUS.CONFIRMED) ||
                    info.status ===
                    CONSTANTS.HALL_BOOKING_STATUS.BOOKED_PAY_INITIAL_AMOUNT ||
                    info.status ===
                    CONSTANTS.HALL_BOOKING_STATUS
                      .FINAL_PAYMENT_DUE_AND_CONTRACT ||
                    info.status ===
                    CONSTANTS.HALL_BOOKING_STATUS.AMOUNT_DUE_TO_HCCC ? (
                    <CommonButton
                      style={{
                        display:
                          info.status == "FORM_FILLED" ||
                            info.status == "FORM_TO_BE_SIGNED" ||
                            info.status == "CLOSED" ||
                            info.status === "FORM_SIGNED" ||
                            info.status === "BOOKED"
                            ? "none"
                            : "block",
                      }}
                      sx={{ float: "inline-end" }}
                      onClick={() => {
                        if (
                          info.status ===
                          CONSTANTS.POOJA_BOOKING_STATUS.CONFIRMED
                        ) {
                          navigate(`/${RoutingURLs.devoteePoojaHallCart}`, {state: {id: info?.id}})
                        } else if (
                          info.status ===
                          CONSTANTS.HALL_BOOKING_STATUS
                            .BOOKED_PAY_INITIAL_AMOUNT
                        ) {
                          onPayNowNavigate(
                            info.additionalData?.initialAmountToPay,
                            info.id,
                            info.requestType,
                            info.status
                          );
                        } else if (
                          info.status ===
                          CONSTANTS.HALL_BOOKING_STATUS
                            .FINAL_PAYMENT_DUE_AND_CONTRACT
                        ) {
                          onPayNowNavigate(
                            info.additionalData?.finalAmountToPay,
                            info.id,
                            info.requestType,
                            info.status
                          );
                        } else if (
                          info.status ===
                          CONSTANTS.HALL_BOOKING_STATUS.AMOUNT_DUE_TO_HCCC
                        ) {
                          onPayNowNavigate(
                            info.additionalData?.settlementAmount,
                            info.id,
                            info.requestType,
                            info.status
                          );
                        }
                      }}
                    >
                      {buttonContext(info.status)}
                    </CommonButton>
                  ) : (
                    ""
                  )}
                  {(info.requestType == "E" && info.hallContractFormId) ? <Link onClick={() => onClickStatus(info, true)}>View Contract Form</Link> : ""}

                </Box>
                {/* <Box className={styles.locationPriestDate}>
                    <Box className={styles.locationAndPriest}>
                      <Box className={styles.statusImage}>
                        {info.status ===
                        CONSTANTS.POOJA_BOOKING_STATUS.BOOKED ? (
                          <img
                            src="/images/done_all.svg"
                            className={styles.smallImage}
                          />
                        ) : (
                          <img
                            src="/images/error.svg"
                            className={styles.smallImage}
                          />
                        )}
                        <Typography
                          className={styles.locationAndPriestNames}
                          style={{
                            color:
                              info.status ===
                              CONSTANTS.POOJA_BOOKING_STATUS.BOOKED
                                ? "#43A022"
                                : "#992D0D",
                            fontWeight: "700",
                          }}
                        >
                          Status : {info.status}
                        </Typography>
                      </Box>
                      {info.status !==
                        CONSTANTS.POOJA_BOOKING_STATUS.CANCELLED && info.status !== "CANCELREQUEST"  ? (
                        <Box className={styles.statusImage}>
                          <img
                            src="/images/cancel.svg"
                            className={styles.smallImage}
                          />
                          <Typography
                            className={styles.poojaBookingCancel}
                            onClick={() => handleCancelClick(info)}
                          >
                            Cancel Booking
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Box> */}
              </Box>
            </Box>
          ))}
        </div>
        <Dialog
          open={openCancelDialog}
          onClose={handleCancelDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "562px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Cancel Booking"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleCancelDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent>
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              Are you sure you want to cancel your Pooja?
            </Typography>
            <Grid>
              <CustomInputLabel>Reason for cancel?</CustomInputLabel>
              <Grid xs={12} sm={3} item>
                <TextareaAutosize
                  style={{
                    height: "50px",
                    width: "300px",
                    backgroundColor: "#fff9e4",
                    borderRadius: "8px",
                  }}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Grid>
            </Grid>
            <div style={{ float: "right" }}>
              <CommonOutlinedButton
                onClick={handleCancelDialogClose}
                sx={{ marginRight: "10px" }}
              >
                cancel
              </CommonOutlinedButton>
              <CommonButton onClick={handleProceedCancel} disabled={isLoading}>
              {isLoading ? (
                <>
                  <ClipLoader color="#fff" loading={isLoading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Yes"
              )}
            </CommonButton>
            </div>
          </DialogContent>
        </Dialog>
        {totalRecords > 5 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={5}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </Box>
    );
  };

  const renderEmptyData = () => {
    return (
      <>
        <Box className={styles.headButton}>
          <Typography className={styles.heading}>Pooja/Hall Booking</Typography>
        </Box>
        <EmptyPage
          imgUrl="/images/EmptyBookPooja.svg"
          subComponent={
            <CommonButton onClick={onClickBookPooja}>
              Book Pooja/Hall
            </CommonButton>
          }
          typographyText="No Pooja/Hall Booked"
        />
      </>
    );
  };

  const handleOpenPaymentDialog = () => {
    setOpenPaymentDialog(true);
  };

  const handlePaymentDialogClose = () => {
    setOpenPaymentDialog(false);
  };

  const handleProceed = () => {
    setIsOpen(false);
    navigate(
      `/creditPayment?amount=${totalAmount}&donationType=${requestType}&status=undefined`
    );
  }

  const typeRequest = () => {
    if (selectedPaymentMode == "credit card") {
      return requestType;
    } else {
      return "RI57I80"
    }
  }

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: getUserName()?.toUpperCase(),
      },
    })
      .then((res) => {
        setPayPalAddToCart(res.data)
      })
      .catch((err) => {
        console.log(err);

        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, [])

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      const cartItemObjects = JSON.parse(storedCartItems);
      setItemList(cartItemObjects);
    }
  }, []);


  const dialogComponent = () => {
    return (
      <>
        <Dialog
          open={openPaymentDialog}
          onClose={handlePaymentDialogClose}
          aria-labelledby="cancel-dialog-title"
          PaperProps={{
            sx: {
              // height: "calc(100% - 300px)",
              width: "400px",
              margin: "64px",
              maxWidth: "504px",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            },
          }}
        >
          {/* {loading ? <ClipLoader /> : null} */}
          <div
            style={{
              backgroundColor: "#882E14",
              width: "auto",
              height: "40px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Payment Mode"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handlePaymentDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                // top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ marginTop: "-20px" }}>
            {dialogLoading ?
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "50px",
                }}
              >
                <BounceLoader color="#22A699" loading={dialogLoading} size={45} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please wait...
                </span>
              </div> : <div>
                <DevoteeModeOfPayment
                  setDialogLoading={setDialogLoading}
                  setOpenPaymentDialog={setOpenPaymentDialog}
                  setIsOpen={props.setIsOpen}
                  setSelectedPaymentMode={setSelectedPaymentMode}
                  amount={totalAmount}
                  donationPurpose={requestType}
                  setButtonDisable={setButtonDisable}
                  itemsList={itemIds}
                />
              </div>}

          </DialogContent>
          <Grid sx={{ display: "flex", gap: "10px", margin: "0px 10px" }}>
            <Box sx={{ padding: "0px 10px" }}>
              {!buttonDisable ? <CommonButton
                sx={{ margin: " 16px 0" }}
                disabled={buttonDisable}
                onClick={handleProceed}
              >
                Proceed
              </CommonButton> : ""}
            </Box>
            <Box sx={{ padding: "0px 10px" }}>
              {!buttonDisable ? <CommonOutlinedButton
                sx={{ margin: " 16px 0" }}
                onClick={handlePaymentDialogClose}
              >
                Cancel
              </CommonOutlinedButton> : ""}
            </Box>
          </Grid>
        </Dialog></>
    )
  }

  return (
    <HcccCard className={styles.BookedPoojaLayout}>
      <ToastComponent />
      {dialogComponent()}
      {bookedPoojaList.length === 0 ? (
        <>{renderEmptyData()}</>
      ) : (
        <>{renderWithData()}</>
      )}
    </HcccCard>
  );
};

export default BookedPooja;
